import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import ToggleFilters from "components/molecules/ToggleFilters";
import { debugModeArgument } from "utils/debugModeArgument";

const ToggleFilterPanel = ({
  className,
  onFilterToggleChange,
  lehrerInnenTotalCount,
  lehrerInnenFilter,
  digitalTotalCount,
  digitalFilter,
  totalCount,
  title = "Toggle Filter",
}) => {
  const componentBaseClass = "sal-toggle-filter-panel";
  const componentClassName = classnames(componentBaseClass, className);

  return (
    <div
      className={componentClassName}
      data-cv-debug={debugModeArgument("true")}
      data-cv-debug-system={debugModeArgument("SAL")}
      data-cv-debug-component={debugModeArgument("ToggleFilterPanel")}
    >
      {title && <h1 className={`${componentBaseClass}__title`}>{title}</h1>}
      <div className={`${componentBaseClass}__toggle-container`}>
        <ToggleFilters
          onFilterToggleChange={onFilterToggleChange}
          lehrerInnenTotalCount={lehrerInnenTotalCount}
          lehrerInnenFilter={lehrerInnenFilter}
          digitalTotalCount={digitalTotalCount}
          digitalFilter={digitalFilter}
          totalCount={totalCount}
        />
      </div>
    </div>
  );
};

ToggleFilterPanel.propTypes = {
  className: PropTypes.string,
  onFilterToggleChange: PropTypes.func.isRequired,
  lehrerInnenTotalCount: PropTypes.number,
  lehrerInnenFilter: PropTypes.bool,
  digitalTotalCount: PropTypes.number,
  digitalFilter: PropTypes.bool,
  totalCount: PropTypes.number,
  title: PropTypes.string,
};

export default ToggleFilterPanel;
